import script from "./ObjetivesRowDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./ObjetivesRowDashboard.vue?vue&type=script&setup=true&lang=js"

import "./ObjetivesRowDashboard.vue?vue&type=style&index=0&id=173f76d1&lang=css"

const __exports__ = script;

export default __exports__